/**
 * @file: usePrompt.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { PromptScreenProps } from '@euler/app/flows/common/PromptScreen';
import { useNavigationRef } from '@euler/functions/navigation/NavigationContainerRefContext';
import { withPrompt } from '@euler/utils';
import { StackActions } from '@react-navigation/native';
import { useCallback } from 'react';
import { Platform } from 'react-native';

export const usePrompt = () => {
  const navigationRef = useNavigationRef();
  return useCallback(
    async (
      props: Omit<
        PromptScreenProps,
        'onConfirm' | 'onCancel' | 'onChange' | 'confirmOnClose'
      >,
    ) => {
      if (Platform.OS === 'web') {
        return await new Promise<string | undefined>(resolve => {
          navigationRef.dispatch(
            StackActions.push('_prompt', {
              ...props,
              confirmOnClose: true,
              onConfirm: (value: string) => {
                resolve(value);
              },
              onCancel: () => {
                resolve(undefined);
              },
            }),
          );
        });
      }
      return await withPrompt({
        title: props.title,
        message: props.message,
        defaultValue: props.defaultValue,
        confirmButtonStyle: props.destructive ? 'destructive' : 'default',
        confirmButtonText: props.confirmButtonText,
        cancelButtonText: props.cancelButtonText,
      });
    },
    [navigationRef],
  );
};
